import { v4 as uuidv4 } from 'uuid'

export const getInitialTextList = (length, initialValue = '') => {
  return Array.from({ length }, () => ({ text: initialValue, id: uuidv4() }))
}
